import attributes from '../constants/attributes';

const ejectDependencies = (liveDocument, blockTemplateId) => {
  const dependencies = liveDocument.querySelectorAll(
    `[${attributes.BLOCK_TEMPLATE_DEPENDENCY_ATTRIBUTE}="${blockTemplateId}"]`
  );

  dependencies.forEach((element) => {
    element.remove();
  });
};

export default ejectDependencies;
